import {Injectable} from '@angular/core';
import {of} from 'rxjs';

@Injectable({providedIn: 'root'})
export class Routes {
  private headerRouteList: Array<any> = [
    // {
    //   groupId: 'Mgr',
    //   groupName: '管理中心',
    //   permissionCode: 'Mgr',
    // }, {
    //   groupId: 'Mgr.Library',
    //   groupName: '资料库',
    //   permissionCode: 'Mgr.Library',
    // }
  ];

  private sideRouteList: Array<any> = [
    {
      groupId: 'Mgr',
      name: '公告栏',
      permissionCode: 'Mgr.Notice',
      children: [{
        name: '公告',
        router: '/layout/notice/board',
        permissionCode: 'Mgr.Notice.Board',
      }, {
        name: '发布历史',
        router: '/layout/notice/history',
        permissionCode: 'Mgr.Notice.History',
      }]
    },
    {
      groupId: 'Mgr',
      name: '明细导出',
      permissionCode: 'Mgr.Export',
      children: [{
        name: '按月明细导出',
        router: '/layout/detailExport/export',
        permissionCode: 'Mgr.Export.Month',
      }, {
        name: '按天明细导出',
        router: '/layout/detailExport/exportday',
        permissionCode: 'Mgr.Export.Day',
      }, {
        name: '导出设置',
        router: '/layout/detailExport/setting',
        permissionCode: 'Mgr.Export.Setting',
      }]
    },
    {
      groupId: 'Mgr',
      name: '基本信息',
      permissionCode: 'Mgr.BasicInfo',
      children: [{
        name: '产品管理',
        router: '/layout/basicInfo/product',
        permissionCode: 'Mgr.BasicInfo.Product',
      }, {
        name: '字典字段设置',
        router: '/layout/basicInfo/dictionary',
        permissionCode: 'Mgr.BasicInfo.Dictionary',
      }, {
        name: '半天事务管理',
        router: '/layout/basicInfo/halfDay',
        permissionCode: 'Mgr.BasicInfo.HalfDay',
      }, {
        name: '行政区域管理',
        router: '/layout/basicInfo/area',
        permissionCode: 'Mgr.BasicInfo.Area',
      }, {
        name: '拜访传递信息',
        router: '/layout/basicInfo/callMessage',
        permissionCode: 'Mgr.BasicInfo.CallMessage',
      }, {
        name: '角色定义',
        router: '/layout/basicInfo/role',
        permissionCode: 'Mgr.BasicInfo.Role',
      }, {
        name: '角色与权限',
        router: '/layout/basicInfo/permissionsRole',
        permissionCode: 'Mgr.BasicInfo.PermissionsRole',
      }, {
        name: '科室管理',
        router: '/layout/basicInfo/dept',
        permissionCode: 'Mgr.BasicInfo.Dept',
      }
      ]
    },
    {
      groupId: 'Mgr',
      name: '人员区域',
      permissionCode: 'Mgr.Person',
      children: [{
        name: '人员管理',
        router: '/layout/person/manager',
        permissionCode: 'Mgr.Person.Manager',
      }, {
        name: '岗位管理',
        router: '/layout/person/territory',
        permissionCode: 'Mgr.Person.Territory',
      }, {
        name: '辖区管理',
        router: '/layout/person/areaAdjust',
        permissionCode: 'Mgr.Person.AreaAdjust',
      }]
    },
    {
      groupId: 'Mgr',
      name: '客户管理',
      permissionCode: 'Mgr.Client',
      children: [{
        name: '客户管理',
        router: '/layout/client/client',
        permissionCode: 'Mgr.Client.Client',
      }, {
        name: '机构信息',
        router: '/layout/client/insinfo',
        permissionCode: 'Mgr.Client.Institution',
      }]
    },
    {
      groupId: 'Mgr',
      name: '导入导出管理',
      permissionCode: 'Mgr.ImExPort',
      children: [{
        name: '导入指标',
        router: '/layout/im-ex-port',
        permissionCode: 'Mgr.ImExPort.SaleTarget',
      },
      {
        name: '纯销报告导出',
        router: '/layout/im-ex-port/pure-sale-mg',
        permissionCode: 'Mgr.ImExPort.PureSale',
      }]
    },
    {
      groupId: 'Mgr',
      name: '销量管理',
      permissionCode: 'Mgr.SaleTargetMg',
      children: [{
        name: '销量预估查询',
        router: '/layout/sale-target-mg',
        permissionCode: 'Mgr.SaleTargetMg.Querty',
      }]
    },
    {
      groupId: 'Mgr',
      name: '活动会议',
      permissionCode: 'Mgr.Campaign', 
      children: [{
        name: '会议信息',
        router: '/layout/campagin',
        permissionCode: 'Mgr.Campaign.Info',
      }]
    },
    {
      groupId: 'Mgr',
      name: '照片查看',
      permissionCode: 'Mgr.Photos',
      children: [{
        name: '照片查看',
        router: '/layout/photos/view',
        permissionCode: 'Mgr.Photos.View',
      }]
    },
    {
      groupId: 'Mgr',
      name: '角色权限与系统参数',
      permissionCode: 'Mgr.RoleSystem',
      children: [{
        name: '角色管理',
        router: '/layout/roles/manager',
        permissionCode: 'Mgr.RoleSystem.Manager',
      }, {
        name: '权限定义',
        router: '/layout/roles/defined',
        permissionCode: 'Mgr.RoleSystem.Defined',
      }, {
        name: '系统参数',
        router: '/layout/roles/system',
        permissionCode: 'Mgr.RoleSystem.System',
      }]
    },
    {
      groupId: 'Mgr',
      name: '开发者设置',
      permissionCode: 'Mgr.Developer',
      children: [{
        name: '页面设置',
        router: '/layout/developer/setpage',
        permissionCode: 'Mgr.RoleSystem.SetPage',
      }]
    },
    {
      groupId: 'Mgr',
      name: '资料库',
      permissionCode: 'Mgr.Library',
      children: [{
        name: '资料发布',
        router: '/layout/library/publish',
        permissionCode: 'Mgr.Library.Publish',
      }, {
        name: '管理中心',
        router: '/layout/library/manager',
        permissionCode: 'Mgr.Library.ManagerCenter',
      }]
    },
    {
      groupId: 'Mgr',
      name: '问卷库',
      permissionCode: 'Mgr.Survey',
      children: [{
        name: '协访问卷',
        router: '/layout/surey/coaching/coaching',
        permissionCode: 'Mgr.Survey.Coaching',
      },{
        name: '会议问卷',
        router: '/layout/surey/meet/CAMPAIGN',
        permissionCode: 'Mgr.Survey.Meet',
      },
      ]
    },
    {
      groupId: 'Mgr',
      name: '管理员页面',
      permissionCode: 'Mgr.ParaSetting',
      children: [{
        name: '管理员参数',
        router: '/layout/paraSetting/admin',
        permissionCode: 'Mgr.ParaSetting.Admin',
      }]
    },
    {
      groupId: 'Mgr',
      name: '路线',
      permissionCode: 'Mgr.RouteLine',
      children: [{
        name: '路线查看',
        router: '/layout/routeLine/route',
        permissionCode: 'Mgr.RouteLine.Route',
      }]
    }
  ];


  public getHeaderRoutes() {
    return of(this.headerRouteList);
  }

  public getSideRoutes() {
    return of(this.sideRouteList);
  }

}
